document.addEventListener('DOMContentLoaded', function () {
  const magazineSections = document.querySelectorAll('.dr-magazine');

  magazineSections.forEach(function (section) {
    const loadMoreWrap = section.querySelector('[data-dr-magazine-load-more]');
    if (!loadMoreWrap) return;

    const mainCards = Array.from(
      section.querySelectorAll('.dr-magazine__column--main [data-dr-magazine-card]')
    );

    const sideCards = Array.from(
      section.querySelectorAll('.dr-magazine__column--side [data-dr-magazine-card]')
    );

    const allCards = mainCards.concat(sideCards);

    const loadMoreBtn = loadMoreWrap.querySelector('[data-dr-magazine-load-more-btn]');
    const loadLessBtn = loadMoreWrap.querySelector('[data-dr-magazine-load-less-btn]');
    const stepCount = parseInt(loadMoreWrap.getAttribute('data-initial-count'), 10) || 12;

    const mainStep = Math.ceil(stepCount / 2);
    const sideStep = Math.floor(stepCount / 2);

    let visibleMain = mainStep;
    let visibleSide = sideStep;

    if (!allCards.length || allCards.length <= stepCount) {
      loadMoreWrap.hidden = true;
      return;
    }

    function updateCards() {
      mainCards.forEach(function (card, index) {
        card.classList.toggle('is-hidden', index >= visibleMain);
      });

      sideCards.forEach(function (card, index) {
        card.classList.toggle('is-hidden', index >= visibleSide);
      });

      const allVisible =
        visibleMain >= mainCards.length &&
        visibleSide >= sideCards.length;

      const isCollapsed =
        visibleMain <= mainStep &&
        visibleSide <= sideStep;

      if (loadMoreBtn) loadMoreBtn.hidden = allVisible;
      if (loadLessBtn) loadLessBtn.hidden = isCollapsed;

      loadMoreWrap.hidden = false;
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleMain = Math.min(visibleMain + mainStep, mainCards.length);
        visibleSide = Math.min(visibleSide + sideStep, sideCards.length);
        updateCards();
      });
    }

    if (loadLessBtn) {
      loadLessBtn.addEventListener('click', function () {
        visibleMain = mainStep;
        visibleSide = sideStep;
        updateCards();

        const navOffset = 120;
        const sectionTop = section.getBoundingClientRect().top + window.pageYOffset - navOffset;

        window.scrollTo({
          top: sectionTop,
          behavior: 'smooth'
        });
      });
    }

    updateCards();
  });
});